var path = '/client/front-office/modules/layout/modules/app/views/app-external.html';
var html = "<!-- Main content -->\n<div class=\"app-content\" ui-view=\"app\">\n    <div>external</div>\n    <div ui-view=\"content\"></div>\n</div>\n";
window.angular.module('AppTemplates').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;